import { motion } from "framer-motion";
import { MapPin, Clock, Phone } from "lucide-react";

export const LocationSection = () => {
  return (
    <section 
      id="ubicacion"
      data-testid="location-section"
      className="relative py-24 bg-black"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-left mb-12"
        >
          <span className="text-neon-cyan text-sm font-bold uppercase tracking-widest">
            Ubicación
          </span>
          <h2 className="mt-4 text-4xl md:text-5xl font-black uppercase tracking-tight text-white">
            Visítanos en
            <br />
            <span className="text-neon-green text-glow-green">Rancagua</span>
          </h2>
          <p className="mt-6 text-lg text-gray-400 max-w-2xl">
            Te esperamos para que conozcas nuestras instalaciones y a nuestro equipo. 
            ¡Tu transformación comienza aquí!
          </p>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Map */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex-1"
          >
            <div 
              className="relative w-full h-[400px] lg:h-[500px] overflow-hidden border border-white/10"
              style={{ boxShadow: "0 0 30px rgba(0, 255, 0, 0.1)" }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3333.4898899453536!2d-70.73636!3d-34.1638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c70a7a7e1ef3%3A0x2c2c2c2c2c2c2c2c!2sAv.%20Einstein%20290%2C%20Rancagua!5e0!3m2!1ses!2scl!4v1699999999999!5m2!1ses!2scl"
                width="100%"
                height="100%"
                style={{ border: 0, filter: "grayscale(80%) invert(92%) contrast(90%)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación Inspirion GYM"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            </div>
          </motion.div>

          {/* Info Cards */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:w-80 flex flex-col gap-4"
          >
            {/* Address */}
            <div className="p-6 bg-dark-card border-l-4 border-l-neon-green">
              <div 
                className="inline-flex items-center justify-center w-12 h-12 mb-4 bg-neon-green/10"
                style={{ boxShadow: "0 0 15px rgba(0, 255, 0, 0.3)" }}
              >
                <MapPin className="w-6 h-6 text-neon-green" />
              </div>
              <h3 className="font-bold text-white uppercase tracking-tight mb-2">
                Dirección
              </h3>
              <p className="text-gray-400">
                Av. Einstein 290, Oficina 512
                <br />
                Rancagua, Chile
              </p>
              <a 
                href="https://maps.app.goo.gl/tg6bk2jexWFgjWvaA"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-neon-green text-sm font-semibold hover:underline"
              >
                Ver en Google Maps →
              </a>
            </div>

            {/* Hours */}
            <div className="p-6 bg-dark-card border-l-4 border-l-neon-cyan">
              <div 
                className="inline-flex items-center justify-center w-12 h-12 mb-4 bg-neon-cyan/10"
                style={{ boxShadow: "0 0 15px rgba(0, 255, 255, 0.3)" }}
              >
                <Clock className="w-6 h-6 text-neon-cyan" />
              </div>
              <h3 className="font-bold text-white uppercase tracking-tight mb-2">
                Horarios
              </h3>
              <p className="text-gray-400">
                Lunes a Viernes: 7:00 - 21:00
                <br />
                Sábados: 9:00 - 14:00
              </p>
            </div>

            {/* Contact */}
            <div className="p-6 bg-dark-card border-l-4 border-l-neon-magenta">
              <div 
                className="inline-flex items-center justify-center w-12 h-12 mb-4 bg-neon-magenta/10"
                style={{ boxShadow: "0 0 15px rgba(255, 0, 255, 0.3)" }}
              >
                <Phone className="w-6 h-6 text-neon-magenta" />
              </div>
              <h3 className="font-bold text-white uppercase tracking-tight mb-2">
                Contacto
              </h3>
              <p className="text-gray-400">
                WhatsApp: +56 9 6695 1278
              </p>
              <a 
                href="https://wa.me/56966951278"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-neon-magenta text-sm font-semibold hover:underline"
              >
                Enviar mensaje →
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
